import type {Directive} from 'vue';
import {useDisplayMobile} from '@malt/utils';

const focusInput: Directive = {
    mounted(el): void {
        const input = el.querySelector('input');

        const {isDisplayMobile} = useDisplayMobile('Xs');
        if (isDisplayMobile.value) {
            return;
        }

        input?.focus();
    },
};

export {focusInput};
